/* ==================================================
   BM Feedback Tabs — ONE COLUMN (PPT content)
   - Tabs: recommend / trust
   - Pills auto-hide per mode (only products with real data)
   - No charts/graphs, only actual text
================================================== */

(function () {
  function initBmFeedbackTabs() {
    const root = document.getElementById("bm-feedback-tabs");
    if (!root) return;

    // Prevent duplicate init (Shopify section reload)
    if (root.dataset.bmftInit === "1") return;
    root.dataset.bmftInit = "1";

    // ===== PRODUCT DATA (ONLY YOUR PROVIDED CONTENT) =====
    const products = [
      {
        key: "lotion",
        brand: "NikoMom",
        name: "Baby Daily Lotion",
        pillImg:
          "https://cdn.shopify.com/s/files/1/0666/7409/8246/files/NikoMom_Baby_Daily_Lotion_Front_d1440142-d30a-4471-b67c-a8a16312cb7e.jpg?v=1765001759",

        recommend: {
          badge: "I recommend NikoMom",
          title: "",
          sub: "",
          rows: [
            {
              val: "100%",
              text: "hydration boost - dermatologically tested",
            },
            {
              val: "100%",
              text: "moisture boost (dermatologically tested) to keep baby skin moisturized all day long.",
            },
            {
              val: "40%",
              text: "After 24 hours, baby skin is 40% more moisturized, providing long-lasting softness and protection throughout the day.",
            },
          ],
          tags: [{ t: "Long-lasting softness", dot: "#7c3aed" }],
        },

        trust: {
          badge: "I trust NikoMom",
          title: "",
          sub: "",
          rows: [
            { val: "100%", text: "parents noticed softer skin after first use." },
            { val: "100%", text: "parents reported no sticky or greasy feel." },
          ],
          tags: [
            { t: "Softer skin (100%)", dot: "#22c55e" },
            { t: "Non-sticky feel (100%)", dot: "#111827" },
          ],
        },
      },

      {
        key: "oil",
        brand: "NikoMom",
        name: "Baby Massage Oil",
        pillImg:
          "https://cdn.shopify.com/s/files/1/0666/7409/8246/files/NikoMom_Baby_Massage_Oil_Front_3d5ead5e-12da-41fa-800b-9be0ff012cf3.jpg?v=1765001759",

        recommend: {
          badge: "I recommend NikoMom",
          title: "",
          sub: "",
          rows: [
            {
              val: "100%",
              text: "Within 30 minutes, NikoMom Baby Massage Oil boosts skin moisture by over 100%.",
            },
            {
              val: "35%",
              text: "Even after a full day, skin remains 35% more moisturized — keeping dryness away until the next massage.",
            },
          ],
          tags: [{ t: "Locks in softness", dot: "#7c3aed" }],
        },

        // NOT AVAILABLE (so pills should hide this product in Trust tab)
        trust: null,
      },

      {
        key: "rash",
        brand: "NikoMom",
        name: "Diaper Rash Cream",
        pillImg:
          "https://cdn.shopify.com/s/files/1/0666/7409/8246/files/NikoMom_Diaper_Rash_Cream_1.png?v=1765001759",

        recommend: null, // DONT HAVE IT YET

        trust: {
          badge: "I trust NikoMom",
          title: "",
          sub: "",
          rows: [
            { val: "50%", text: "parents noticed improvement in just 2 days." },
            { val: "100%", text: "parents noticed complete improvement in just 7 days." },
            {
              val: "100%",
              text: "parents agreed that diaper rash did not reappear with continuous use after 14 days.",
            },
          ],
          tags: [],
        },
      },

      {
        key: "wash",
        brand: "NikoMom",
        name: "Head-to-Toe Wash",
        pillImg:
          "https://cdn.shopify.com/s/files/1/0666/7409/8246/files/NikoMom_Head-to-Toe_Wash_Front_8ca45184-f7ef-485a-a71a-e406d32fd1f5.jpg?v=1765252708",

        recommend: null, // DONT HAVE IT YET

        trust: {
          badge: "I trust NikoMom",
          title: "",
          sub: "",
          rows: [
            { val: "100%", text: "of parents agree the wash is tear-free." },
            { val: "100%", text: "of parents agree it is gentle and mild on their baby's skin." },
            { val: "100%", text: "of parents agree it leaves their baby's skin soft and clean." },
          ],
          tags: [],
        },
      },
    ];

    // ===== Elements =====
    const heroBtns = root.querySelectorAll(".bmft-hero");
    const pillsWrap = root.querySelector(".bmft-pills");

    const badgeEl = root.querySelector("#bmftBadge");
    const titleEl = root.querySelector("#bmftTitle");
    const subEl = root.querySelector("#bmftSub");
    const rowsEl = root.querySelector("#bmftRows");
    const tagsEl = root.querySelector("#bmftTags");

    // ===== State =====
    let mode = "recommend";
    let activeKey = products[0]?.key || "";
    let visibleProducts = [];

    // ===== Helpers =====
    const isMeaningfulMode = (block) => {
      if (!block) return false;
      const rows = Array.isArray(block.rows) ? block.rows : [];
      return rows.length > 0; // if rows exist, it is real data
    };

    function setHeroActive() {
      heroBtns.forEach((b) => {
        const is = b.dataset.mode === mode;
        b.classList.toggle("is-active", is);
        b.setAttribute("aria-selected", is ? "true" : "false");
      });
    }

    function renderPills() {
      if (!pillsWrap) return;

      visibleProducts = products.filter((p) => isMeaningfulMode(p[mode]));

      // Hide pills area if only 0 or 1 product (optional nicer UI)
      if (visibleProducts.length <= 1) {
        pillsWrap.style.display = "none";
      } else {
        pillsWrap.style.display = "";
      }

      // Fix activeKey if current is not visible
      if (!visibleProducts.some((p) => p.key === activeKey)) {
        activeKey = visibleProducts[0]?.key || products[0]?.key || "";
      }

      pillsWrap.innerHTML = visibleProducts
        .map((p) => {
          const active = p.key === activeKey ? "is-active" : "";
          return `
            <button class="bmft-pill ${active}" type="button" role="tab" data-key="${p.key}">
              <img class="bmft-pill-img" src="${p.pillImg}" alt="">
              <span class="bmft-pill-text">
                <span class="bmft-pill-t1">${p.brand}</span>
                <span class="bmft-pill-t2">${p.name}</span>
              </span>
            </button>
          `;
        })
        .join("");
    }

    function setActivePillUI() {
      root.querySelectorAll(".bmft-pill").forEach((btn) => {
        btn.classList.toggle("is-active", btn.dataset.key === activeKey);
      });
    }

    function renderRows(rows) {
      rowsEl.innerHTML = (rows || [])
        .map((r) => {
          const val = (r.val || "").trim();
          const text = (r.text || "").trim();
          // allow "100% moisture boost" style values too
          const safeVal = val.replace(/</g, "&lt;").replace(/>/g, "&gt;");
          return `
            <div class="bmft-row">
              <div class="bmft-val">${safeVal}</div>
              <div class="bmft-text">${text}</div>
            </div>
          `;
        })
        .join("");
    }

    function renderTags(tags) {
      const list = Array.isArray(tags) ? tags : [];
      if (!list.length) {
        tagsEl.innerHTML = "";
        tagsEl.style.display = "none";
        return;
      }
      tagsEl.style.display = "";
      tagsEl.innerHTML = list
        .map(
          (t) => `
            <span class="bmft-tag">
              <span class="bmft-tag-dot" style="background:${t.dot || "#22c55e"}"></span>
              <span>${t.t || ""}</span>
            </span>
          `
        )
        .join("");
    }

    function setContent() {
      const list = visibleProducts.length ? visibleProducts : products;
      const p = list.find((x) => x.key === activeKey) || list[0];
      if (!p) return;

      const d = p[mode];
      if (!d) return;

      badgeEl.textContent = d.badge || "";
      titleEl.textContent = d.title || "";
      subEl.textContent = d.sub || "";

      renderRows(d.rows);
      renderTags(d.tags);

      setActivePillUI();
    }

    function bindEvents() {
      heroBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          mode = btn.dataset.mode;
          setHeroActive();
          renderPills();
          setContent();
        });
      });

      // Delegated click works after re-render
      pillsWrap.addEventListener("click", (e) => {
        const b = e.target.closest(".bmft-pill");
        if (!b) return;
        activeKey = b.dataset.key;
        setContent();
      });
    }

    // ===== Init =====
    setHeroActive();
    renderPills();
    setContent();
    bindEvents();
  }

  document.addEventListener("DOMContentLoaded", initBmFeedbackTabs);
  document.addEventListener("shopify:section:load", initBmFeedbackTabs);
})();
